const ns = "DOCUMENTS_TEMPLATES";
export const ADD_TEMPLATES = `${ns}_ADD_TEMPLATES`;
